module.exports = __webpack_public_path__ + "static/ARB_PHOTOGRAPHY_5-47212382399371de85c5dcdc44faacde.jpg";